import React from 'react';

import { GiHotMeal } from 'react-icons/gi';
import { SiCoffeescript } from 'react-icons/si';
import { BiWine } from 'react-icons/bi';
import { Logo } from '../assets';

const Navbar = () => {

  return (
    <div className='fixed top-0 w-screen lg:px-32 z-50 '>
      <div className='mx-5 mb-1 mt-3 flex justify-between bg-white items-start p-3 shadow-xl rounded-3xl'>
        <a href="/"><img src={Logo} alt="logo" className='w-16'/></a>
        <a href='/comida' className='flex flex-col items-center'>
            <GiHotMeal className='text-6xl p-4 bg-secondary rounded-full text-white '/>
        </a>          
        <a href='/desayuno' className='flex flex-col items-center'>
            <SiCoffeescript className='text-6xl p-4 bg-secondary rounded-full text-white '/>
        </a>          
        <a href='/bebidas' className='flex flex-col items-center'>
            <BiWine className='text-6xl p-4 bg-secondary rounded-full text-white '/>
        </a>
      </div>
    </div>
  )
}

export default Navbar